interface ProblemSectionProps {
  onCTAClick: () => void;
}

const problems = [
  {
    title: 'ITに詳しい人が社内にいない',
    desc: 'セキュリティのことは「なんとなく業者に任せているだけ」という状態が続いていませんか？',
  },
  {
    title: 'ウイルス対策だけで十分か不安',
    desc: '「ウイルスソフトを入れているから大丈夫」と思っていても、それだけでは守れない脅威が増えています。',
  },
  {
    title: '何から対策すればいいかわからない',
    desc: 'セキュリティ対策と言っても種類が多すぎて、どこから手をつければいいのか途方に暮れてしまう。',
  },
  {
    title: '取引先からセキュリティ対策を求められている',
    desc: '最近、取引先や大手企業からセキュリティに関する確認書の提出を求められるケースが増えています。',
  },
];

const ProblemSection: React.FC<ProblemSectionProps> = ({ onCTAClick }) => (
  <section id="problem" className="py-24 bg-slate-50">
    <div className="max-w-5xl mx-auto px-6">
      {/* Heading */}
      <div className="text-center mb-16">
        <span className="inline-block text-sky-600 text-sm font-bold tracking-widest uppercase mb-4">
          お悩み
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-800 leading-tight">
          こんなお悩み、ありませんか？
        </h2>
        <p className="mt-4 text-slate-500 text-base max-w-xl mx-auto leading-relaxed">
          神奈川県内の中小企業から、同じような声が多く寄せられています。
        </p>
      </div>

      {/* Problem cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {problems.map((p) => (
          <div
            key={p.title}
            className="bg-white rounded-xl p-7 border border-slate-100 flex flex-col gap-3 transition-all duration-200 hover:-translate-y-1 hover:border-sky-200"
          >
            <h3 className="font-bold text-slate-800 text-base">{p.title}</h3>
            <p className="text-slate-500 text-sm leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>

      {/* Bridge text */}
      <div className="mt-14 bg-sky-600 rounded-2xl px-8 py-8 text-center">
        <p className="text-white text-xl font-bold leading-relaxed mb-2">
          どれか一つでも当てはまるなら、<br className="sm:hidden" />
          今すぐ対策を始めるべきタイミングです。
        </p>
        <p className="text-sky-100 text-sm mt-3 mb-6">
          まずは現状を確認するだけでも構いません。無料でご相談いただけます。
        </p>
        <button
          onClick={onCTAClick}
          className="whitespace-nowrap inline-block bg-white text-sky-600 font-bold px-8 py-3 rounded-full text-sm hover:bg-sky-50 transition-all duration-200 cursor-pointer"
        >
          無料診断を申し込む
        </button>
      </div>
    </div>
  </section>
);

export default ProblemSection;
